<div class="all">
    <div class="content" [ngClass]="{'padding1vh':componentName =='לוח שנה למוסד'}">
        <div class="title-content">
            <div class="icon {{IconName}}"></div>
            <div class="title" [ngClass]="{'font-lg':componentName =='פניות'}">{{componentName}}</div>
        </div>
        <div class="btn-content">
            <div>
                <button class="refresh" [hidden]="componentName != 'תלמידים' && componentName != 'מסלולים'" (click)="dataService.SetIsRefresh(true)"></button>
            </div>
            <div>
                <button class="search" [hidden]="componentName!='תלמידים'" (click)="openSearch()"></button>
            </div>
            <div>
                <button class="close-btn" [hidden]="componentName!='תלמידים'"></button>
            </div>
            <ng-content></ng-content>
        </div>
    </div>
</div>